import React, { PureComponent, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PeriodPropTypes } from '../../shared/propTypes/period';
import { OptionsPropType } from '../../shared/propTypes/common';

import {
  fetchInitialDataForGLAccountListAddEditModal,
} from './store/actions';
import {
  sharedSelectors,
  isFetchingInitialDataForAddAndEditModalSelector,
  accountOptionsSelector,
  listNameOptionsSelector,
} from './store/selectors';

import {
  GLAccountPropTypes,
  GLAccountListPropTypes,
} from './GLAccountList.propTypes';

import schema from './glAccountList.schema';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

const ModalTitles = {
  ADD: 'Add GL Account List',
  EDIT: 'Edit GL Account List',
};

class AddEditModal extends PureComponent {
  static propTypes = {
    period: PeriodPropTypes.isRequired,
    entityToEdit: GLAccountPropTypes,
    glAccounts: GLAccountListPropTypes,
    accountOptions: OptionsPropType,
    listNameOptions: OptionsPropType,
    hideModal: PropTypes.func.isRequired,

    fetchInitialData: PropTypes.func.isRequired,
    isFetchingInitialData: PropTypes.bool.isRequired,
    saveEntity: PropTypes.func.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    openForEdit: PropTypes.bool,

    isFetchingInitialDataForModal: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { period, fetchInitialData } = this.props;

    fetchInitialData(period);
  }

  componentDidUpdate(prevProps) {
    const { period, fetchInitialData } = this.props;
    if (prevProps.period !== period) {
      fetchInitialData(period);
    }
  }

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit, entityToEdit } = this.props;

    saveEntity({
      ...formData,
      periodName: period.name,
    }, openForEdit, {
      params: {
        periodName: period.name,
        ...entityToEdit,
      },
      callback: resetForm,
    });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      accountOptions,
      listNameOptions,
      hideModal,
      isVisible,
      isSavingInProgress,
      isFetchingInitialDataForModal,
    } = this.props;

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        className="add-edit-gl-account-list-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        isLoading={isFetchingInitialDataForModal}
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            accountOptions,
            listNameOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, glAccounts, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{
          entities: glAccounts,
          openForEdit,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  accountOptions: accountOptionsSelector(state),
  listNameOptions: listNameOptionsSelector(state),
  glAccounts: sharedSelectors.entitiesSelector(state),
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
  isFetchingInitialDataForModal: isFetchingInitialDataForAddAndEditModalSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialData: fetchInitialDataForGLAccountListAddEditModal,
  }
)(AddEditModal);
